import "./info-card.css";

interface InfoCardProps {
    Icon: React.ComponentType;
    title: string;
    children: React.ReactNode;
}

export default function InfoCard({
    Icon,
    title,
    children,
}: InfoCardProps): React.ReactElement {
    return (
        <div className="info-card">
            <Icon />
            <div className="info-card__header">{title}</div>
            <div className="info-card__content">{children}</div>
        </div>
    );
}
